import type { IconProps } from './IconProps';

export const ArrowUpRightIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 17}
    height={props.height ?? 17}
    {...props}
  >
    <path
      d="M5.62565 4.85571C5.25746 4.85571 4.95898 5.15419 4.95898 5.52238C4.95898 5.89057 5.25746 6.18905 5.62565 6.18905H10.6828L5.15425 11.7176C4.8939 11.978 4.8939 12.4001 5.15425 12.6605C5.4146 12.9208 5.83671 12.9208 6.09706 12.6605L11.6257 7.13186V12.189C11.6257 12.5572 11.9241 12.8557 12.2923 12.8557C12.6605 12.8557 12.959 12.5572 12.959 12.189V5.52238C12.959 5.15419 12.6605 4.85571 12.2923 4.85571H5.62565Z"
      fill="currentColor"
    />
  </svg>
);
